import axios from "axios";
import UserService from "@/services/user.service";

class AuthService {
  async login(user) {
    const pData = new URLSearchParams();
    pData.append("email", user.email);
    pData.append("password", user.password);

    //Prima Chiamata - Login dell'utente
    await axios.post(process.env.VUE_APP_ROOT + "/users/login.json", pData).then((response) => {
      if (response.data.data) {
        user.accessToken = response.data.data;
        //Tolgo la password dalla memoria
        user.password = null;
        localStorage.setItem("user", JSON.stringify(user));
      }
    });

    //Seconda chiamata - Leggo i dati dell'utente
    return await this.whoAmI();
  }

  async whoAmI() {
    try {
      let response = await UserService.whoAmI();

      let u2 = response.data;
      let user = JSON.parse(localStorage.getItem("user"));
      user = { ...user, ...u2 };
      console.log("in whoami", user);
      //Memorizzo il risultato nel localstorage
      localStorage.setItem("user", JSON.stringify(user));
      return user;
    } catch (error) {
      console.log(error.message);
      return null;
    }
  }

  logout() {
    localStorage.removeItem("user");
  }

  register(user) {
    const pData = new URLSearchParams();
    console.log(user);
    pData.append("first_name", user.first_name);
    pData.append("last_name", user.last_name);
    pData.append("email", user.email);
    pData.append("password", user.password);
    pData.append("password_confirm", user.password_confirm);
    pData.append("organization_id", user.organization_id);
    pData.append("code", user.code);
    if(user.src_langs)
      for( var i = 0; i < user.src_langs.length; i++)
        pData.append("src_lang_id[]", user.src_langs[i].id);
    if(user.dest_langs)
      for( var y = 0; y < user.dest_langs.length; y++)
        pData.append("dest_lang_id[]", user.dest_langs[y].id);
    // pData.append("source_lang_id[]", user.src_langs);
    // pData.append("dest_lang_id[]", user.dest_langs);
    //Devo passarlo così se no non capisce che è un array
    // for (var i = 0; i < user.langs.length; i++) {
    //   pData.append("dest_lang_id[]", user.langs[i].id);
    // }

    return axios.post(process.env.VUE_APP_ROOT + "/users/register.json", pData);
  }
}

export default new AuthService();
